import Swiper from 'swiper';
import {Autoplay, EffectFade} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "swiper/css/effect-fade";
export const mvSlider = () => {
  const mvSlider = new Swiper(".js-slider",{
    modules: [Autoplay, EffectFade],
    loop: true, 
    slidesPerView: 1,
    speed: 600,
    autoplay: true,
    effect: "fade",
    autoplay: {
      delay: 3000
    }
  });
};